import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { from, Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { ManageEmailTemplateService } from '../services/manage-email-template.service';
import { MasterDataService } from '../services/masterdata.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserRolesService } from '../services/user-roles.service';
import { EmailTemplatePlaceholders } from '../models/email-template-placeholders'; 
import { ModuleName } from '../constants/constants';
import $ from "jquery";
import 'bootstrap';
import { Modal } from 'bootstrap';
import DOMPurify from 'dompurify';

interface Person {
    name: string;
}

/** URL schemes permitted on href/src inside the Outlook preview. */
const SAFE_URI_SCHEMES = /^(?:https?:|mailto:|tel:|cid:|data:image\/(?:png|jpeg|gif|webp);base64,)/i;

/**
 * Restricts href/src to an explicit scheme allowlist. Registered once at module
 * load. Relative URLs (no scheme) are permitted; anything with a scheme outside
 * the allowlist - javascript:, vbscript:, data:text/html - has the attribute removed.
 */
DOMPurify.addHook('afterSanitizeAttributes', (node: Element) => {
    ['href', 'src'].forEach((attr) => {
        if (!node.hasAttribute(attr)) return;
        const value = (node.getAttribute(attr) || '').trim();
        const hasScheme = /^[a-z][a-z0-9+.-]*:/i.test(value);
        if (hasScheme && !SAFE_URI_SCHEMES.test(value)) {
            node.removeAttribute(attr);
        }
    });
});

/**
 * Shared DOMPurify policy for email-template content.
 *
 * NOTE: ALLOWED_URI_REGEXP is deliberately NOT used. In DOMPurify 3.x it is applied
 * to every attribute value, so it also strips non-URI layout attributes such as
 * border/colspan/cellpadding that Outlook templates rely on. DOMPurify already blocks
 * javascript:, vbscript: and non-image data: URIs by default; the hook above restricts
 * the remaining href/src schemes to an explicit allowlist.
 */
const SANITIZE_OPTIONS = {
    USE_PROFILES: { html: true },
    ADD_ATTR: ['target'],
    FORBID_TAGS: ['script', 'style', 'iframe', 'object', 'embed', 'form', 'input', 'button', 'base', 'meta', 'link'],
    FORBID_ATTR: ['srcset', 'formaction', 'xlink:href', 'action'],
    ALLOW_DATA_ATTR: false
};

/** Static, developer-authored preview chrome. Contains no user input. */
const PREVIEW_STYLES = `
                    * {
                        margin: 0;
                        padding: 0;
                        box-sizing: border-box;
                    }
                    body {
                        font-family: 'Segoe UI', 'Tahoma', sans-serif;
                        background-color: #f3f3f3;
                        padding: 20px;
                        font-size: 14px;
                    }
                    .container {
                        max-width: 900px;
                        margin: 0 auto;
                        background-color: white;
                        border: 1px solid #bdbfc4;
                        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                    }
                    .header {
                        background-color: #f5f5f5;
                        border-bottom: 1px solid #bdbfc4;
                        padding: 16px;
                        background: linear-gradient(to bottom, #f9f9f9, #f0f0f0);
                    }
                    .header-title {
                        font-size: 18px;
                        color: #262626;
                        margin-bottom: 8px;
                        font-weight: 500;
                    }
                    .email-info {
                        background-color: #fafafa;
                        padding: 12px 16px;
                        border-bottom: 1px solid #e5e5e5;
                    }
                    .info-row {
                        display: flex;
                        margin-bottom: 6px;
                        line-height: 1.5;
                    }
                    .info-label {
                        font-weight: 600;
                        color: #262626;
                        min-width: 80px;
                        margin-right: 12px;
                    }
                    .info-value {
                        color: #595959;
                        word-break: break-word;
                        flex: 1;
                    }
                    .subject-row {
                        background-color: #ffffff;
                        padding: 12px 16px;
                        border-bottom: 1px solid #e5e5e5;
                    }
                    .subject {
                        font-size: 16px;
                        font-weight: 600;
                        color: #262626;
                    }
                    .body {
                        padding: 16px;
                        color: #262626;
                        line-height: 1.6;
                    }
                    .body img {
                        max-width: 100%;
                        height: auto;
                    }
                    .footer {
                        background-color: #f5f5f5;
                        border-top: 1px solid #bdbfc4;
                        padding: 12px 16px;
                        text-align: center;
                        font-size: 12px;
                        color: #7f8080;
                    }
                    .empty-value {
                        color: #999;
                        font-style: italic;
                    }
`;


@Component({
    selector: 'app-manage-email-template',
    templateUrl: './manage-email-template.component.html',
    styleUrls: ['./manage-email-template.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ManageEmailTemplateComponent implements OnInit {
    styleSet: any;
    showPreview: boolean = false;
    constructor(private _httpClient: HttpClient, private http: HttpClient, private manageEmailTemplateService: ManageEmailTemplateService, private masterdataService: MasterDataService, private router: Router,
        private activatedRoute: ActivatedRoute,private userRoleService: UserRolesService,) {
        this.items$ = this.input$.pipe(
            map((term) => this.searchPeople(term))
        );
    }
    config: any;
    editorData: any;
    updatedContent: any;
    templateNames: any;
    selectedTemplate: any = null;
    emailTitle: string = "";
    emailFrom: string = "";
    emailTo: any = [];
    emailSubject: string = "";
    emailTemplate_CC: any = [];
    emailTemplate_BCC: any = [];
    emailTemplate_ID: string = "";
    placeHoldersData: EmailTemplatePlaceholders[] = [];
    placeHoldersDataPop: boolean = false;
    saveEmailTemplate: boolean = false;
    modifiedBy: any = "";
    modifiedTime: any = "";
    userRoleID: number;
    private subscription: Subject<void> = new Subject<void>();
    public items$: Observable<Person[]>;
    public input$ = new Subject<string | null>();
    ModuleName=ModuleName;

      SaveData(data: string) {
         this.editorData = data;
      } 

    private searchPeople(term: string | null): Person[] {
        const searchTerm = term ? term : '';
        return [
            { name: 'Facilitator' },
            { name:'RemovedFacilitator'},
            { name: 'Coordinator' },
            { name: 'Requester' },  
            { name: 'ResponsiblePPMD' },
            { name: 'CountryMailbox' },
            { name: 'EventProgramMailbox' },
            { name: 'SubscriptionAdmin' },
            { name: 'ChiefChemist' },
            { name: 'User' }
        ].filter((person) => {
            return person.name.toLowerCase().startsWith(searchTerm.toLowerCase());
        });
    }
    ngOnInit() { 
        
        this.getEmailTemplate();
        
        this.userRoleService.getUserRoleID().subscribe((id) => {
            this.userRoleID = Number(id);
            
        });
    }

    masterData() {
        this.masterdataService.getMasterDataDetails().pipe(takeUntil(this.subscription)).subscribe((masterData) => {
            this.placeHoldersData = masterData.Placeholders;
            });
      
    };

    getPlaceHolderData() {
        this.masterData();
        this.placeHoldersDataPop = true;
    }

    getEmailTemplate() {

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const templateId = urlParams.get('id')

        this.manageEmailTemplateService.getEmailTemplateData().pipe(takeUntil(this.subscription)).subscribe(response => {
            this.templateNames = [];
          if (response) {
            response = response.Data;
            response.map(res => {
                    this.templateNames.push({
                        Name: res.EmailTemplates_Name,
                        ID: res.EmailTemplates_ID,
                       
                    })
                });
                this.onSelectTemplate(templateId);
            }
        });
    }

    onSelectTemplate(templateId) {
       
        this.showPreview = false;
        this.selectedTemplate = templateId;

        this.manageEmailTemplateService.getEmailTemplateDataByID(templateId).pipe(takeUntil(this.subscription)).subscribe(res => {
            res = res.Data;
            let modifyDate = res.EmailTemplates_ModifiedDate.split(" ");
            let modifiedDate = modifyDate[0].split("/");
            modifiedDate = ((modifiedDate[0] > 8) ? (modifiedDate[0]) : ('0' + (modifiedDate[0]))) + '/' + ((modifiedDate[1] > 9) ? modifiedDate[1] : ('0' + modifiedDate[1])) + '/' + modifiedDate[2];

            let modifyTime = modifyDate[1];
            modifyTime = modifyTime.split(":");
            modifyTime = modifyTime[0] + ":" + modifyTime[1];
            modifyDate = modifiedDate + " - " + modifyTime + " " + modifyDate[2] + " CST";
        if (res && Object.keys(res).length > 0) {
            this.emailTitle = res.EmailTemplates_Title;
            this.emailFrom = res.EmailTemplates_From;
            if (res.EmailTemplates_To != null) {
                  this.emailTo = res.EmailTemplates_To.split(",");
            }
            this.emailSubject = res.EmailTemplates_Subject;
            this.editorData = res.EmailTemplates_EmailContent;
            if (res.EmailTemplates_CC != null) {
                  this.emailTemplate_CC = res.EmailTemplates_CC.split(",");;
            }
            if (res.EmailTemplates_BCC != null) {
                  this.emailTemplate_BCC = res.EmailTemplates_BCC.split(",");;
            }

            this.emailTemplate_ID = res.EmailTemplates_ID;
            this.modifiedTime = modifyDate;
            this.modifiedBy = res.EmailTemplates_ModifiedBy;

            if (this.emailTo.length === 1 && this.emailTo[0] === "") {
                this.emailTo = [];
            }
            if (this.emailTemplate_CC.length === 1 && this.emailTemplate_CC[0] === "") {
                this.emailTemplate_CC = [];
            }
            if (this.emailTemplate_BCC.length === 1 && this.emailTemplate_BCC[0] === "") {
                this.emailTemplate_BCC = [];
            }
           }
        });

        
    }

    onPreview() {
        this.showPreview = true;
        this.updatedContent = this.editorData;
    }

    previewInOutlook() {
        // Build the Outlook-like preview using safe DOM APIs only.
        // No user-controlled value is ever passed to an HTML-parsing sink
        // (document.write / innerHTML / outerHTML / insertAdjacentHTML).
        const newWindow = window.open('', 'OutlookPreview', 'width=1000,height=700,scrollbars=yes');
        if (!newWindow) {
            return;
        }

        // Build recipient lists
        const toRecipients = this.emailTo.join('; ');
        const ccRecipients = this.emailTemplate_CC.join('; ');
        const bccRecipients = this.emailTemplate_BCC.join('; ');
        const currentDateTime = new Date().toLocaleString('en-US', {
            weekday: 'short',
            month: 'short',
            day: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });

        const doc = newWindow.document;

        // Reset any previously rendered preview in the reused named window.
        doc.head.replaceChildren();
        doc.body.replaceChildren();

        doc.title = `Email Preview - ${this.emailSubject || ''}`;

        const charset = doc.createElement('meta');
        charset.setAttribute('charset', 'UTF-8');
        doc.head.appendChild(charset);

        const viewport = doc.createElement('meta');
        viewport.setAttribute('name', 'viewport');
        viewport.setAttribute('content', 'width=device-width, initial-scale=1.0');
        doc.head.appendChild(viewport);

        // Static stylesheet: developer-authored constant, no interpolation.
        const styleEl = doc.createElement('style');
        styleEl.textContent = PREVIEW_STYLES;
        doc.head.appendChild(styleEl);

        doc.body.appendChild(
            this.buildPreviewBody(doc, toRecipients, ccRecipients, bccRecipients, currentDateTime)
        );
    }

    /**
     * Constructs the preview DOM. Every dynamic value is assigned through
     * textContent; the rich email body is inserted as a sanitized DocumentFragment.
     */
    private buildPreviewBody(
        doc: Document,
        toRecipients: string,
        ccRecipients: string,
        bccRecipients: string,
        currentDateTime: string
    ): HTMLElement {
        const el = (tag: string, className?: string): HTMLElement => {
            const node = doc.createElement(tag);
            if (className) {
                node.className = className; // static, developer-authored class names
            }
            return node;
        };

        const infoRow = (label: string, value: string): HTMLElement => {
            const row = el('div', 'info-row');
            const labelEl = el('span', 'info-label');
            labelEl.textContent = label;
            const valueEl = el('span', 'info-value');
            valueEl.textContent = value; // textContent - never parsed as HTML
            row.appendChild(labelEl);
            row.appendChild(valueEl);
            return row;
        };

        const container = el('div', 'container');

        const header = el('div', 'header');
        const headerTitle = el('div', 'header-title');
        headerTitle.textContent = 'Email Preview';
        header.appendChild(headerTitle);
        container.appendChild(header);

        const emailInfo = el('div', 'email-info');
        emailInfo.appendChild(infoRow('From:', this.emailFrom || ''));

        if (toRecipients) {
            emailInfo.appendChild(infoRow('To:', toRecipients));
        } else {
            const row = el('div', 'info-row');
            const labelEl = el('span', 'info-label');
            labelEl.textContent = 'To:';
            const valueEl = el('span', 'info-value');
            const emptyEl = el('span', 'empty-value');
            emptyEl.textContent = 'No recipients';
            valueEl.appendChild(emptyEl);
            row.appendChild(labelEl);
            row.appendChild(valueEl);
            emailInfo.appendChild(row);
        }

        if (ccRecipients) {
            emailInfo.appendChild(infoRow('Cc:', ccRecipients));
        }
        if (bccRecipients) {
            emailInfo.appendChild(infoRow('Bcc:', bccRecipients));
        }
        emailInfo.appendChild(infoRow('Date:', currentDateTime));
        container.appendChild(emailInfo);

        const subjectRow = el('div', 'subject-row');
        const subject = el('div', 'subject');
        subject.textContent = this.emailSubject || '';
        subjectRow.appendChild(subject);
        container.appendChild(subjectRow);

        const body = el('div', 'body');
        body.appendChild(this.sanitizeEmailFragment(doc, this.editorData));
        container.appendChild(body);

        const footer = el('div', 'footer');
        footer.textContent = 'This is a preview of your email template';
        container.appendChild(footer);

        return container;
    }

    /**
     * Sanitizes rich email-template HTML and returns live DOM nodes owned by the
     * target document. Uses the same DOMPurify policy as sanitizeEmailHtml().
     */
    private sanitizeEmailFragment(doc: Document, html: any): DocumentFragment {
        if (!html) {
            return doc.createDocumentFragment();
        }

        const sanitized: unknown = DOMPurify.sanitize(String(html), {
            ...SANITIZE_OPTIONS,
            RETURN_DOM_FRAGMENT: true
        } as any);

        // Defensive: if DOMPurify ever returns a string instead of a fragment,
        // fall back to a text node rather than parsing it as HTML.
        if (!sanitized || (sanitized as Node).nodeType !== Node.DOCUMENT_FRAGMENT_NODE) {
            const fallback = doc.createDocumentFragment();
            fallback.appendChild(doc.createTextNode(String(sanitized ?? '')));
            return fallback;
        }

        return doc.importNode(sanitized as DocumentFragment, true);
    }
    private sanitizeEmailHtml(html: any): string {
        if (!html) return '';
        return DOMPurify.sanitize(String(html), SANITIZE_OPTIONS);
    }

    private escapeHtml(text: string): string {
        if (!text) return '';
        const map = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#039;'
        };
        return text.replace(/[&<>"']/g, (m) => map[m]);
    }

    saveData() {
       if (this.emailTo.length === 0 && this.emailTemplate_CC.length === 0) {
        const saveEmailPopup = new Modal(document.getElementById('saveEmailPopup'));
        saveEmailPopup.show();
         //   $("#saveEmailPopup").modal("show");
        }
        else {
                const UpdatedEmailTemplateData = {
                    EmailTemplates_ID: this.emailTemplate_ID,
                    EmailTemplates_Name: this.emailTitle,
                    EmailTemplates_EmailContent: this.editorData,
                    EmailTemplates_From: this.emailFrom,
                    EmailTemplates_To: this.emailTo.toString(),
                    EmailTemplates_CC: this.emailTemplate_CC.toString(),
                    EmailTemplates_BCC: this.emailTemplate_BCC.toString(),
                    EmailTemplates_Subject: this.emailSubject
                };
                this.manageEmailTemplateService.EditEmailTemplateData(UpdatedEmailTemplateData).pipe(takeUntil(this.subscription)).subscribe(res => {
                    if (res) {
                        res = res.Data;
                        if (res === true) {
                            this.saveEmailTemplate = true;
                            const saveEmailModal = new Modal(document.getElementById('saveEmailModal'));
                            saveEmailModal.show();
                          //  $("#saveEmailModal").modal("show");
                        }
                    }
                });
        }
    }

    testMail() {
        const EmailTemplate  = {
            EmailTemplates_ID: this.emailTemplate_ID,
            EmailTemplates_Name: this.emailTitle,
            EmailTemplates_EmailContent: this.editorData,
            EmailTemplates_From: this.emailFrom,
            EmailTemplates_To: this.emailTo.toString(),
            EmailTemplates_CC: this.emailTemplate_CC.toString(),
            EmailTemplates_Subject: this.emailSubject
        };
        this.manageEmailTemplateService.SendTestEmail(EmailTemplate ).pipe(takeUntil(this.subscription)).subscribe(res => {
            if (res) {
                res = res.Data;
                console.log(res);
                if (res === true) {
                    this.saveEmailTemplate = false;
                    const saveEmailModal = new Modal(document.getElementById('saveEmailModal'));
                    saveEmailModal.show();
                  //  $("#saveEmailModal").modal("show");                  
                }
            }
        });

    }
    successModelOk() {
        this.router.navigate(["/searchEmailTemplate"], {
            relativeTo: this.activatedRoute,
        });
    }
}
